<template>
  <div class="index-page-bg-fff">
    <!--余额 & 消息通知-->
    <div class="tab-notice-line">
      <div class="left-tab-part">
        <div class="money_title">
          <div
            class="money_each"
            v-for="(item, index) in dataBoardMoneyParams"
            :key="index"
          >
            <img
              :class="[index == 1 ? 'bgOne_no' : 'bgOne']"
              :src="item.bgOneUrl"
              :style="item.bgOneStyle"
              alt=""
            />
            <img
              :class="[index == 1 ? 'bgTow_no_bg' : 'bgTow']"
              v-if="!!item.bgTowUrl"
              :src="item.bgTowUrl"
              :style="item.bgTowStyle"
              alt=""
            />
            <span class="bgTow_no" v-else :style="item.bgTowStyle"></span>
            <div class="text">
              <span>{{ item.name }}</span>
              <span>{{ item.amount }}</span>
              <div class="btn" @click="jumpClick(item.path)">查看详情</div>
            </div>
          </div>
        </div>

        <div class="margin-bg"></div>

        <div class="recharge-card-wrap">
          <el-card class="box-card custom-header" shadow="never">
            <div slot="header" class="clearfix">
              <span>充值账户信息</span>
            </div>
            <el-row>
            <el-col :span="12">
              <div class="recharge-item">
                <span class="recharge-label">充值账户：</span>
                <span class="recharge-value">{{ receiptInfo.accountName || "" }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="recharge-item">
                <span class="recharge-label">开户行：</span>
                <span class="recharge-value">{{ receiptInfo.depositBank || "" }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="recharge-item">
                <span class="recharge-label">充值账号：</span>
                <span class="recharge-value">{{ receiptInfo.accountNumber || "" }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="recharge-item">
                <span class="recharge-label">行&nbsp;&nbsp;&nbsp;别：</span>
                <span class="recharge-value">{{ receiptInfo.bankType || "" }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="recharge-item recharge-item-remark">
                <span class="recharge-label">打款备注：</span>
                <span class="recharge-value">{{ receiptInfo.remark || "" }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="recharge-item">
                <span class="recharge-label">联行号：</span>
                <span class="recharge-value">{{ receiptInfo.bankBranchCode || "" }}</span>
              </div>
            </el-col>
          </el-row>
          </el-card>
        </div>
      </div>

      <!-- 消息通知 -->
      <div class="right-notice-part">
        <div class="notice-header">
          <span class="notice-text">消息通知</span>
          <span v-if="noticeUnreadCount > 0" class="notice-unread-hint"
            >{{ noticeUnreadCount > 99 ? "99+" : noticeUnreadCount }}条未读</span
          >
        </div>
        <div class="notice-list">
          <div v-if="notice_list.length > 0">
            <div
              v-for="(item, index) in notice_list"
              :key="item.id || index"
              :class="['notice-item', { 'is-unread': !item.read }]"
              @click="openNoticeDetail(item)"
            >
              <div class="notice-title">
                <div class="left-div">
                  <span class="notice-bell-wrap">
                    <i class="el-icon-bell"></i>
                    <span v-if="!item.read" class="notice-item-dot"></span>
                  </span>
                  <span class="notice-item-name">{{ item.title }}</span>
                </div>
                <span class="notice-item-date">{{ item.date }}</span>
              </div>
            </div>
          </div>
          <div v-else class="notice-empty">
            <i class="el-icon-bell notice-empty-icon"></i>
            <p class="notice-empty-text">暂无消息通知</p>
            <p class="notice-empty-desc">有新的消息时会在此展示</p>
          </div>
        </div>
      </div>
      <!-- <notice-list></notice-list> -->
    </div>

    <div class="entrance-title">快捷入口</div>

    <!--快捷入口-->
    <div class="data-line">
      <div class="data-item red-item">
        <img
          class="big-icon"
          src="../../../static/home/blue_1.png"
          height="80"
          width="80"
        />
        <button
          class="btnLineFontColor bottom-btn"
          @click="jumpToPage('/task/taskList')"
        >
          发布任务
        </button>
      </div>

      <div class="data-item blue-item">
        <img
          class="big-icon"
          src="../../../static/home/orig_2.png"
          height="80"
          width="80"
        />
        <button
          class="btnLineFontColor bottom-btn"
          @click="jumpToPage('/task/employmentStatement')"
        >
          用工结算
        </button>
      </div>

      <div class="data-item purple-item">
        <img
          class="big-icon"
          src="../../../static/home/pur_3.png"
          height="80"
          width="80"
        />
        <button
          class="btnLineFontColor bottom-btn"
          @click="jumpToPage('/payCenter/billingRecordList')"
        >
          申请开票
        </button>
      </div>

      <div class="data-item green-item">
        <img
          class="big-icon"
          src="../../../static/home/green_4.png"
          height="80"
          width="80"
        />
        <button
          class="btnLineFontColor bottom-btn"
          @click="jumpToPage('/payCenter/electronicReceipt')"
        >
          电子回单
        </button>
      </div>
    </div>

    <!-- 消息详情弹窗 -->
    <el-dialog
      class="notice-detail-dialog"
      :visible.sync="noticeDetailVisible"
      width="640px"
      append-to-body
      :show-close="true"
      @close="closeNoticeDetail"
    >
      <span slot="title" class="notice-dialog-header-title">{{ currentNotice ? currentNotice.title : "消息详情" }}</span>
      <template v-if="currentNotice">
        <div class="notice-detail-content">{{ currentNotice.content || "暂无内容" }}</div>
        <div class="notice-detail-date-wrap">发布日期：{{ currentNotice.date }}</div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getInfo, getNoticeList, markNoticeRead } from "../../api/userMG";
export default {
  name: "index-merchant",
  components: {
    // "notice-list": noticeList,
  },

  data() {
    return {
      notice_list: [],
      noticeDetailVisible: false,
      currentNotice: null,
      dataBoardMoneyParams: [
        {
          amount: "",
          jumpUrl: "/balanceManage",
          name: "可用余额（元）",
          bgOneStyle: {
            width: "22px",
            height: "22px",
            top: "28px",
            left: "19px",
          },
          bgTowStyle: {
            width: "16px",
            height: "16px",
            top: "25px",
            left: "15px",
          },
          bgOneUrl: "../../static/home/icon_home_yue_up.png",
          bgTowUrl: "../../static/home/icon_home_yue_down.png",
          path: "/payCenter/balanceManage",
        },
        {
          dataType: 1,
          amount: "",
          jumpUrl: "/BusinessStatistics",
          name: "累计结算金额（元）",
          bgOneStyle: {
            width: "20px",
            height: "22px",
            top: "28px",
            left: "21px",
          },
          bgTowStyle: {
            width: "15px",
            height: "18px",
            top: "24px",
            left: "31px",
          },
          bgOneUrl: "../../static/home/icon_home_jiesuan_up.png",
          bgTowUrl: "../../static/home/icon_home_jiesuan_down.png",
          path: "/task/employmentStatement",
        },
        {
          dataType: 2,
          amount: "",
          jumpUrl: "/rechargeRecord",
          name: "累计充值金额（元）",
          bgOneStyle: {
            width: "22px",
            height: "22px",
            top: "28px",
            left: "25px",
          },
          bgTowStyle: {
            width: "16px",
            height: "16px",
            top: "25px",
            left: "21px",
          },
          bgOneUrl: "../../static/home/icon_home_chongzhi_up.png",
          bgTowUrl: "../../static/home/icon_home_chongzhi_down.png",
          path: "/payCenter/rechargeRecord",
        },
        {
          dataType: 4,
          amount: "",
          jumpUrl: "/billingRecordList",
          name: "可开票金额（元）",
          bgOneStyle: {
            width: "19px",
            height: "21px",
            top: "29px",
            left: "24px",
          },
          bgTowStyle: {
            width: "15px",
            height: "17px",
            top: "26px",
            left: "20px",
          },
          bgOneUrl: "../../static/home/icon_home_fapiao_up.png",
          bgTowUrl: "",
          path: "/payCenter/billingRecordList",
        },
      ],
      info: {},
      receiptInfo: {},
    };
  },

  computed: {
    noticeUnreadCount() {
      return (this.notice_list || []).filter((n) => !n.read).length;
    },
  },

  created() {
    // // 获取今天和昨天的日期
    // let today = formatDate(new Date());
    // let yesterday = dateFormat(
    //   new Date().setTime(new Date().getTime() - 24 * 60 * 60 * 1000)
    // );
    // this.tabList[0].paramDate = today;
    // this.tabList[1].paramDate = yesterday;
    // this.xhrIsNeedCompleteContractInformation(); // 弹窗 - 合作评估表
    // this.xhrChangeNoticeLetter(); // 弹窗 - 下载变更通知函
    // // 首页数据看板金额查询
    // for (let i = 0; i < this.dataBoardMoneyParams.length; i++) {
    //   if (!!this.dataBoardMoneyParams[i].dataType) {
    //     this.xhrDataBoardMoney(this.dataBoardMoneyParams[i]);
    //   }
    // }
  },

  mounted() {
    getInfo()
      .then((res) => {
        if (res.msg == "success") {
          this.info = res.data;
          this.dataBoardMoneyParams[0].amount = res.data.balance;
          this.dataBoardMoneyParams[1].amount =
            res.data.cumulativeSettlementAmount;
          this.dataBoardMoneyParams[2].amount =
            res.data.cumulativeRechargeAmount;
          this.dataBoardMoneyParams[3].amount = res.data.invoiceAmount;
          this.receiptInfo = res.data.receiptInfo;
          localStorage.setItem("user_info", JSON.stringify(res.data));
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      })
      .catch((err) => {});
    this.fetchNoticeList();
    // this.userMessage = JSON.parse(getLocal("userMessage"));
    // this.whetherCompliance = JSON.parse(getLocal("whetherCompliance"));
    // this.countDown();
    // this.xhrRechargeInfo();
    // this.xhrAccountBalance();
    // this.xhrRiskControlTip(); // 弹窗 - 上传《业务说明交付物》

    // // 如果弹电子合同签约页面则清空历史栈
    // if (localStorage.getItem("routerIndexMer")) {
    //   if (window.history && window.history.pushState) {
    //     // 往历史记录里面添加一条新的当前页面的url
    //     history.pushState(null, null, document.URL);
    //     // 给 popstate 绑定一个方法 监听页面刷新
    //     window.addEventListener("popstate", this.backChange, false); //false阻止默认事件
    //   }
    // }
  },

  methods: {
    // 消息通知列表
    fetchNoticeList() {
      getNoticeList()
        .then((res) => {
          if (res.msg === "success" && res.data) {
            const items = res.data.items || [];
            this.notice_list = items.map((n) => ({
              id: n.id,
              title: n.title || "",
              date: this.formatNoticeDate(n.createdDate != null ? n.createdDate : n.createdAt),
              content: n.content || "",
              read: !!n.read,
            }));
          }
        })
        .catch(() => {});
    },
    formatNoticeDate(createdDate) {
      if (createdDate == null || createdDate === "") return "";
      if (typeof createdDate === "string" && createdDate.length <= 16) return createdDate;
      const d = new Date(typeof createdDate === "number" && createdDate < 1e10 ? createdDate * 1000 : createdDate);
      if (isNaN(d.getTime())) return "";
      const m = d.getMonth() + 1;
      const day = d.getDate();
      return `${m}-${day < 10 ? "0" + day : day}`;
    },
    // 打开消息详情并标已读
    openNoticeDetail(item) {
      this.currentNotice = item;
      this.noticeDetailVisible = true;
      if (!item.read && item.id) {
        item.read = true;
        markNoticeRead(item.id).catch(() => {
          item.read = false;
        });
      }
    },
    closeNoticeDetail() {
      this.noticeDetailVisible = false;
      this.currentNotice = null;
    },
    // 首页数据看板跳转
    jumpClick(path) {
      console.log(path);
      this.$router.push({ path: path });
    },

    // 跳转页面
    jumpToPage(path, origin) {
      this.$router.push({ path: path });
    },

    // 跳转批次数据准备页面
    jumpToBatch() {
      if (this.batchType) {
        this.$router.push({ name: this.batchType });
      }
    },

    // 签署合同倒计时
    countDown() {
      let that = this;
      let t = setInterval(function () {
        if (that.contractCodeTimer > 1) {
          that.contractCodeTimer--;
          that.contractCodeText = "(" + that.contractCodeTimer + "s)";
          that.btnDisabled = false;
        } else {
          clearInterval(t);
          that.contractCodeTimer = that.contractCodeTimer;
          that.contractCodeText = "";
          that.btnDisabled = true;
        }
      }, 1000);
    },

    backChange() {
      this.$router.push({
        path: "/indexMer",
      });
    },
  },

  beforeCreate() {
    // console.log("商户 beforeCreate");
  },

  beforeDestroy() {
    // console.log("商户 beforeDestroy");
  },

  destroyed() {},
};
</script>

<style>
#listRate .el-table__row {
  width: 342px;
  height: 44px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
}

#listRate .has-gutter {
  width: 684px;
  height: 44px;
}

#listRate .has-gutter .el-table_1_column_1 {
  border-left: 1px solid #e5e5e5;
  border-top: 1px solid #e5e5e5;
}

#listRate .has-gutter .el-table_1_column_2 {
  border-left: 1px solid #e5e5e5;
  border-right: 1px solid #e5e5e5;
  border-top: 1px solid #e5e5e5;
}

#listRate .el-table__row .el-table_1_column_1 {
  border-left: 1px solid #e5e5e5;
}

#listRate .el-table__row .el-table_1_column_2 {
  border-left: 1px solid #e5e5e5;
  border-right: 1px solid #e5e5e5;
}

#noticeLetter .dialog-footer > button {
  padding: 0 10px;
}

#noticeLetter p {
  margin: 0 10px 25px 10px;
}

.notice-detail-dialog .el-dialog {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
}
.notice-detail-dialog .el-dialog__header {
  text-align: center;
  padding: 44px 56px 32px;
  border-bottom: 1px solid #f0f0f0;
  background: linear-gradient(to bottom, #fafafa 0%, #fff 100%);
}
.notice-detail-dialog .el-dialog__header .notice-dialog-header-title {
  display: block;
  font-size: 20px;
  font-weight: 600;
  color: #272727;
  letter-spacing: 0.5px;
}
.notice-detail-dialog .el-dialog__header .el-dialog__close {
  color: #8c8c8c;
  font-size: 18px;
}
.notice-detail-dialog .el-dialog__header .el-dialog__close:hover {
  color: #272727;
}
.notice-detail-dialog .el-dialog__body {
  padding: 44px 56px 48px;
  min-height: 200px;
}
.notice-detail-dialog .notice-detail-content {
  font-size: 15px;
  color: #404040;
  line-height: 1.85;
  white-space: pre-wrap;
  word-break: break-all;
  padding: 0;
  margin-bottom: 40px;
}
.notice-detail-dialog .notice-detail-date-wrap {
  font-size: 12px;
  color: #8c8c8c;
  text-align: right;
  white-space: nowrap;
}
.notice-detail-dialog .el-dialog__footer {
  display: none;
}
</style>

<style lang="css" scoped>
.tab-notice-line {
  display: flex;
  justify-content: space-between;
}

.left-tab-part {
  background-color: #ffffff;
  border-radius: 10px;
  width: 63%;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.25s ease;
}
.left-tab-part:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.money_title {
  height: 156px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  background-color: #f0f2f5;
}

.money_each {
  position: relative;
  cursor: pointer;
  width: 23.5%;
  background-color: #fff;
  height: 156px;
  background: linear-gradient(173deg, #ebedee 0%, #ffffff 100%);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.money_each:nth-child(1) {
  /* border: none;
  background: url("../../../static/home/bg_home_balance.png") no-repeat;
  background-size: 100% calc(100% * (168 / 156));
  background-position: center; */
}

.money_each:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(92, 133, 168, 0.18);
  background-color: #57b2ff;
  background: url("../../../static/home/bg_home_balance.png") no-repeat;
  background-size: 100% calc(100% * (168 / 156));
  background-position: center;
}
.money_each:hover .text span {
  color: #fff !important;
}

.money_each:first-child .text span {
  /* color: #fff!important; */
}

.money_each .btn {
  display: block;
  width: 67px;
  height: 20px;
  background: #ffffff;
  border-radius: 8px;
  font-size: 12px;
  font-family: PingFangTC-Regular, PingFangTC;
  color: #1985ff;
  text-align: center;
  line-height: 20px;
  transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;
}
.money_each .btn:hover {
  transform: scale(1.03);
}

.bgOne_no {
  position: absolute;
  z-index: 99;
  backdrop-filter: blur(2px);
  animation: bgOne_no_None 0.2s steps(16) forwards;
  display: block;
}

.bgTow_no_bg {
  position: absolute;
  z-index: 98;
  animation: bgTow_no_None 0.2s steps(16) forwards;
  display: block;
}

.bgOne {
  position: absolute;
  z-index: 99;
  backdrop-filter: blur(2px);
  animation: bgOneNone 0.2s steps(16) forwards;
  display: block;
}

.bgTow {
  position: absolute;
  z-index: 98;
  animation: bgTowNone 0.2s steps(16) forwards;
  display: block;
}

.bgTow_no {
  position: absolute;
  background-color: #1985ff;
  border-radius: 8px;
  z-index: 98;
  animation: bgTowNone 0.2s steps(16) forwards;
  display: block;
}
.money_each .text {
  position: absolute;
  top: 58px;
  display: flex;
  width: 100%;
  height: auto;
  flex-direction: column;
  padding-left: 18px;
}
.money_each .text span {
  display: block;
}
.money_each .text span:nth-child(1) {
  font-size: 12px;
  margin-top: 4px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #8c8c8c;
  margin-bottom: 5px;
}
.money_each .text span:nth-child(2) {
  font-size: 18px;
  font-family: AlibabaSans102Ver2-Medium, AlibabaSans102Ver2;
  color: #272727;
  margin-bottom: 10px;
}
.money_each .text span .btn {
  font-size: 12px;
  font-family: PingFangTC-Regular, PingFangTC;
  color: #1985ff;
}
.margin-bg {
  height: 16px;
  width: 100%;
  background-color: #f0f2f5;
}
.recharge-card-wrap {
  border-radius: 10px;
  overflow: hidden;
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.25s ease;
}
.recharge-card-wrap:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}
.recharge-card-wrap .box-card {
  border-radius: 0;
  border: none;
  box-shadow: none !important;
}
.recharge-card-wrap .box-card .el-card__header,
.recharge-card-wrap .box-card .el-card__body {
  border-radius: 0;
}
.recharge-card-wrap .custom-header .el-card__header span {
  font-size: 16px;
  font-weight: 500;
  color: #272727;
}
.recharge-card-wrap .recharge-item {
  margin-bottom: 14px;
  line-height: 1.6;
  font-size: 14px;
}
.recharge-card-wrap .recharge-label {
  color: #8c8c8c;
  font-size: 13px;
  margin-right: 4px;
}
.recharge-card-wrap .recharge-value {
  color: #272727;
  font-size: 14px;
  word-break: break-all;
}
.recharge-card-wrap .recharge-item-remark .recharge-value {
  color: #f56c6c;
  font-weight: 500;
}
.tab-notice-line .left-tab-part .recharge-card-wrap {
  margin: 0;
}
.tab-notice-line .title {
  height: 56px;
  line-height: 56px;
  border-bottom: 1px solid #e5e5e5;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.tab-notice-line .title .notice-text {
  color: #272727;
  margin-left: 32px;
  cursor: auto;
  text-align: left;
}
.tab-notice-line .left-tab-part .recharge-acc-info {
  padding-top: 24px;
  display: flex;
}
.tab-notice-line .left-tab-part .recharge-acc-info .recharge-acc-info-item {
  width: 50%;
  padding-left: 32px;
}
.tab-notice-line .left-tab-part .recharge-acc-info .recharge-acc-info-item div {
  display: flex;
}
.tab-notice-line
  .left-tab-part
  .recharge-acc-info
  .recharge-acc-info-item
  .lable-info {
  color: #272727;
}
.tab-notice-line
  .left-tab-part
  .recharge-acc-info
  .recharge-acc-info-item
  span {
  font-size: 14px;
  margin-bottom: 16px;
}
.data-line {
  margin-bottom: 36px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.data-line .data-item {
  width: 23%;
  height: 230px;
  background-color: #ffffff;
  padding: 0;
  position: relative;
  text-align: center;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}
.data-line .data-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}
.data-line .data-item .big-icon {
  transition: transform 0.25s ease;
}
.data-line .data-item:hover .big-icon {
  transform: scale(1.05);
}
.data-item .top-bar-img {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
}
.data-item .big-icon {
  display: block;
  margin: 41px auto 33px;
}
.data-item .num-title {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #595959;
}
.data-item .num {
  height: 40px;
  line-height: 40px;
  font-size: 32px;
  color: #272727;
  margin: 16px auto 48px;
}
.data-item .bottom-btn {
  width: 100%;
  height: 44px;
  line-height: 42px;
  border: 1px solid #f56c6c;
  font-size: 16px;
}
.red-item .bottom-btn {
  color: #f56c6c;
  border: 1px solid #f56c6c;
}
.blue-item {
  position: relative;
}
.purple-item {
  position: relative;
}
.green-item {
  position: relative;
}
.blue-item .num-dianzi {
  font-size: 12px;
  color: #8c8c8c;
  position: absolute;
  left: 0;
  bottom: 100px;
  width: 100%;
}

.blue-item .bottom-btn {
  color: #409eff;
  border: 1px solid #409eff;
}
.purple-item .bottom-btn {
  color: #6255f2;
  border: 1px solid #6255f2;
}

.green-item .bottom-btn {
  color: #26bfa6;
  border: 1px solid #26bfa6;
}
.data-line .data-item .bottom-btn {
  width: 80%;
  height: 44px;
  line-height: 44px;
  font-size: 16px;
  border-radius: 8px;
  background-color: #fff;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
}
.data-line .data-item:hover .bottom-btn {
  transform: scale(1.02);
}
.data-line .red-item:hover .bottom-btn {
  background-color: #f56c6c;
  color: #fff;
  border-color: #f56c6c;
}
.data-line .blue-item:hover .bottom-btn {
  background-color: #409eff;
  color: #fff;
  border-color: #409eff;
}
.data-line .purple-item:hover .bottom-btn {
  background-color: #6255f2;
  color: #fff;
  border-color: #6255f2;
}
.data-line .green-item:hover .bottom-btn {
  background-color: #26bfa6;
  color: #fff;
  border-color: #26bfa6;
}
.right-notice-part {
  width: 35%;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.25s ease;
}
.right-notice-part:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}
.right-notice-part .notice-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  padding: 0 24px;
  border-bottom: 1px solid #ebeef5;
  box-sizing: border-box;
}
.right-notice-part .notice-text {
  font-size: 16px;
  font-weight: 500;
  color: #272727;
  line-height: 1;
}
.right-notice-part .notice-unread-hint {
  font-size: 12px;
  color: #f56c6c;
  background: #fef0f0;
  padding: 2px 8px;
  border-radius: 10px;
  line-height: 18px;
  font-weight: 500;
}
.right-notice-part .notice-list {
  padding: 8px 12px 16px;
  overflow-y: auto;
  max-height: 264px;
}
.right-notice-part .notice-list .notice-item {
  padding: 10px 12px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.2s ease;
}
.right-notice-part .notice-list .notice-item:hover {
  background: #f5f7fa;
}
.right-notice-part .notice-list .notice-item .notice-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-width: 0;
}
.right-notice-part .notice-list .notice-item .notice-title .left-div {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;
  margin-right: 12px;
}
.right-notice-part .notice-list .notice-item .notice-bell-wrap {
  position: relative;
  flex-shrink: 0;
  margin-right: 8px;
  width: 16px;
  height: 16px;
}
.right-notice-part .notice-list .notice-item .el-icon-bell {
  font-size: 16px;
  color: #1985ff;
  line-height: 16px;
}
.right-notice-part .notice-list .notice-item .notice-item-dot {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #f56c6c;
}
.right-notice-part .notice-list .notice-item .notice-item-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #606266;
}
.right-notice-part .notice-list .notice-item.is-unread .notice-item-name {
  font-weight: 600;
  color: #303133;
}
.right-notice-part .notice-list .notice-item .notice-item-date {
  flex-shrink: 0;
  color: #909399;
  font-size: 12px;
  white-space: nowrap;
}
.right-notice-part .notice-list .notice-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  min-height: 160px;
}
.right-notice-part .notice-list .notice-empty-icon {
  display: block;
  margin-bottom: 12px;
  font-size: 40px;
  color: #c0c4cc;
}
.right-notice-part .notice-list .notice-empty-text {
  font-size: 14px;
  color: #909399;
  margin: 0 0 4px 0;
}
.right-notice-part .notice-list .notice-empty-desc {
  font-size: 12px;
  color: #c0c4cc;
  margin: 0;
}

.entrance-title {
  margin-top: 24px;
  margin-bottom: 16px;
  font-size: 16px;
  color: #272727;
}

@keyframes bgOne_no_Hover {
  0% {
    transform: translate(0px, 0px);
  }

  100% {
    transform: translate(-4px, 3px);
  }
}

@keyframes bgTow_no_Hover {
  0% {
    transform: translate(0px, 0px);
  }

  100% {
    transform: translate(4px, -3px);
  }
}

@keyframes bgOne_no_None {
  0% {
    transform: translate(-4px, 3px);
  }

  100% {
    transform: translate(0px, 0px);
  }
}

@keyframes bgTow_no_None {
  0% {
    transform: translate(4px, -3px);
  }

  100% {
    transform: translate(0px, 0px);
  }
}

@keyframes bgOneHover {
  0% {
    transform: translate(0px, 0px);
  }

  100% {
    transform: translate(4px, 3px);
  }
}

@keyframes bgOneNone {
  0% {
    transform: translate(4px, 3px);
  }

  100% {
    transform: translate(0px, 0px);
  }
}

@keyframes bgTowHover {
  0% {
    transform: translate(0px, 0px);
  }

  100% {
    transform: translate(-4px, -3px);
  }
}

@keyframes bgTowNone {
  0% {
    transform: translate(-4px, -3px);
  }

  100% {
    transform: translate(0px, 0px);
  }
}

.info-value {
  color: #595959;
  vertical-align: top;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
</style>
<style lang="css">
.custom-header .el-card__header span {
  font-size: 16px;
  font-weight: 500;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/work/index.vue